import { render, staticRenderFns } from "./DevicesSettingsPage.vue?vue&type=template&id=1ff4b9ba&scoped=true&"
import script from "./DevicesSettingsPage.vue?vue&type=script&lang=js&"
export * from "./DevicesSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./DevicesSettingsPage.vue?vue&type=style&index=0&id=1ff4b9ba&prod&scoped=true&lang=css&"
import style1 from "./DevicesSettingsPage.vue?vue&type=style&index=1&id=1ff4b9ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff4b9ba",
  null
  
)

export default component.exports